<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" [innerHTML]="props.label"></label>
  <div>
    <form [formGroup]="smartlistForm">

      <div formArrayName="items">
        <div *ngFor="let itemForm of items.controls; let i = index">
          <div [formGroup]="itemForm" class="form-control-group mb-2">
            <div class="me-2">
              <label *ngIf="props.label && props.hideLabel !== true" for="smartlistKey_{{i}}" i18n="@@Key">Ключ</label>
              <input nbInput
                     id="smartlistKey_{{i}}"
                     fieldSize="small"
                     placeholder="Название параметра"
                     i18n-placeholder="@@SmartlistKeyPlaceholder"
                     formControlName="key"
              />
            </div>

            <div class="me-2">
              <label *ngIf="props.label && props.hideLabel !== true" for="smartlistValue_{{i}}" i18n="@@Value">Значение</label>
              <input nbInput
                     id="smartlistValue_{{i}}"
                     fieldSize="small"
                     placeholder="Значение параметра"
                     i18n-placeholder="@@SmartlistValuePlaceholder"
                     formControlName="value"
              />
            </div>

            <button type="button" i18n-nbTooltip="@@Delete" nbTooltip="удалить" (click)="deleteSmartlistItem(i)" nbButton size="tiny" status="danger">
              <nb-icon icon="close"></nb-icon>
            </button>
          </div>
        </div>
      </div>

      <div>
        <button type="button" i18n-nbTooltip="@@Create" nbTooltip="добавить" (click)="addSmartlistItem()" nbButton size="small" status="control" i18n="@@AddSmartlistItem">
          <nb-icon icon="plus-square-outline"></nb-icon>
          Добавить
        </button>
      </div>
    </form>
  </div>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>

